import { z } from "zod";
import { ExporterWorkspaceMembershipRole } from "./exporter-workspace-membership-role";
import { DbCreateInputOmit } from "../helpers";

export const ExporterWorkspaceMembership = z.object({
  id: z.string(),
  workspaceId: z.string(),
  exporterId: z.string(),
  role: ExporterWorkspaceMembershipRole,
});

export type ExporterWorkspaceMembership = z.infer<typeof ExporterWorkspaceMembership>;

export type CreateExporterMembership = DbCreateInputOmit<ExporterWorkspaceMembership>;
